import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ENTITLEMENTS } from '../application-core/constants';
import DataOptions from '../core/DataOptions';
import HistoryViewer from '../core/HistoryViewer';
import { ProjectConsumer } from '../core/providers/ProjectProvider';
import TripleViewer from '../core/TripleViewer';
import { getGraphFromProject } from '../core/utils/utils';
import ResourceSummaryDetail from './ResourceSummaryDetail';
import DatatypeDetail from './DatatypeDetail';

class DatatypeData extends Component {

  constructor(props) {
    super(props);
    this.state = {
      view: 0
    };
  }

  changeView = (index) => this.setState({ view: index });

  render() {

    const { datatypeIRI, onDeleteDatatype, project, ontologyIRI, buildLink, viewLang,
      hiddenProps, availableAnnotationProperty, useWorkflow, entitlements, projectUsers } = this.props;
    const { view } = this.state;
    const projectGraph = getGraphFromProject(project);

    return (
      <ProjectConsumer>
        {({ defaultLang }) => (
          <div>
            <DataOptions
              handleNotAvailable={true}
              id={datatypeIRI}
              graph={projectGraph}
              changeView={this.changeView}
              view={this.state.view}
              historyOption={true} />
            <div style={{ float: 'right', width: 'calc(100% - 60px)', marginBottom: '20px', paddingLeft: '10px' }}>
              <ResourceSummaryDetail
                handleNotAvailable={true}
                allowIRIchange={false}
                viewLang={viewLang}
                canPun={false}
                useWorkflow={useWorkflow}
                id={datatypeIRI}
                canDeprecate={true}
                graph={projectGraph}
                defaultLang={defaultLang}
                onDeleteResource={onDeleteDatatype}
                permission="https://grafsync.graphifi.com/schema/om-entitlement/editOntology" />
              {view === 0 &&
                <DatatypeDetail
                  useWorkflow={useWorkflow}
                  projectUsers={projectUsers}
                  handleNotAvailable={true}
                  graph={projectGraph}
                  viewLang={viewLang}
                  entitlements={entitlements}
                  expectedTypes={["RdfsDatatype"]}
                  hiddenProps={hiddenProps}
                  defaultLang={defaultLang}
                  availableAnnotationProperty={availableAnnotationProperty}
                  ontologyIRI={ontologyIRI}
                  buildLink={buildLink}
                  project={project}
                  id={datatypeIRI} />}
              {view === 1 &&
                <TripleViewer
                  requiredEntitlement={ENTITLEMENTS.EDIT_ONTOLOGY}
                  handleNotAvailable={true}
                  id={datatypeIRI}
                  graph={projectGraph} />}
              {view === 4 &&
                <HistoryViewer handleNotAvailable={true} id={datatypeIRI} graph={projectGraph} />}
            </div>
          </div>
        )}
      </ProjectConsumer>
    );
  }

}

DatatypeData.propTypes = {
  buildLink: PropTypes.func.isRequired,
  project: PropTypes.string.isRequired,
  datatypeIRI: PropTypes.string.isRequired,
  editingOptions: PropTypes.array,
  viewLang: PropTypes.string,
  hiddenProps: PropTypes.array,
  ontologyIRI: PropTypes.string.isRequired,
  onDeleteDatatype: PropTypes.func.isRequired,
  availableAnnotationProperty: PropTypes.array
};

export default DatatypeData;